import imgFallback from "public/img-fallback.png";
import { Link } from "react-router-dom";
import { Icon, Image } from "@/components/common";
import type { PredictiveSearchResult } from "..";

type Props = {
  result: PredictiveSearchResult;
};

const cardClassName = "flex w-full items-center justify-between bg-white relative text-left";

export const TalentSearchCard = ({ result }: Props) => {
  const content = (
    <>
      <div className="flex items-center gap-2 overflow-hidden">
        <figure className="relative h-[51px] w-[30px] shrink-0 text-[.5rem]">
          <Image src={result.imageUrl || imgFallback} alt={result.imageAlt} fill className="object-cover" />
        </figure>

        <div className="flex flex-col min-w-0">
          <span className="truncate font-medium text-sm">{result.title}</span>
          {result.subtitle && <span className="text-xs font-normal text-secondary">{result.subtitle}</span>}
        </div>
      </div>

      <Icon name="KeyboardArrowRight" className="text-primary" size="1.5rem" />
    </>
  );

  return (
    <Link to={result.href} className={cardClassName}>
      {content}
    </Link>
  );
};
